import cx from 'classnames';
import { format, getYear } from 'date-fns';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';

import { Button } from '../Button';
import ChevronRightIcon from '../assets/svgs/chevron-right.svg';
import TriangleDownIcon from '../assets/svgs/triangle-down.svg';
import styles from './datePicker.module.scss';

interface Props extends ReactDatePickerCustomHeaderProps {
  isShowMonthYear: boolean;
  onClickMonthYear: () => void;
  isMonthly?: boolean;
}

const CustomHeader = ({
  date,
  monthDate,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
  changeYear,
  isShowMonthYear,
  onClickMonthYear,
  isMonthly,
}: Props) => {
  const year = getYear(monthDate);

  const isMonthYear = isMonthly || isShowMonthYear;

  const onClickPrev = () => {
    if (isMonthYear) changeYear(year - 1);
    else decreaseMonth();
  };

  const onClickNext = () => {
    if (isMonthYear) changeYear(year + 1);
    else increaseMonth();
  };

  return (
    <div className={styles.pickerHeader}>
      <Button
        shape='link2'
        className={styles.prevButton}
        onClick={onClickPrev}
        disabled={isMonthYear ? prevYearButtonDisabled : prevMonthButtonDisabled}
      >
        <ChevronRightIcon />
      </Button>
      <Button
        shape='link2'
        className={cx(styles.monthButton, { [styles.isShowMonth]: isMonthYear })}
        onClick={onClickMonthYear}
      >
        {format(date, isMonthYear ? 'yyyy' : 'LLL. yyyy')}
        {!isMonthly && <TriangleDownIcon />}
      </Button>
      <Button
        shape='link2'
        className={styles.nextButton}
        onClick={onClickNext}
        disabled={isMonthYear ? nextYearButtonDisabled : nextMonthButtonDisabled}
      >
        <ChevronRightIcon />
      </Button>
    </div>
  );
};

export default CustomHeader;
